import { useSystem } from "../../hooks/use-system";
import "./style.scss";

function Button({button_text, button_primary_color, button_text_color, button_action, disabled, ...props}) {

    const {config} = useSystem()

    const gradientBtnStyles = config.button_gradient ? 
    {
        background: config.button_gradient,
        boxShadow: 'none',
        border: 'none',
    } 
    : { }

    const buttonStyles = {
        fontSize: config.button_font_size,
        backgroundColor: config.button_primary_color,
        color: button_text_color,
        ...gradientBtnStyles
    }

    return (
                    <button id={"Button"} className="AFsubmitbtn" disabled={disabled} style={buttonStyles} onClick={button_action} {...props}>
                        {button_text}
                    </button>
    )
}

export default Button;